/** Public customer-service contact — keep display + tel: in sync. */
export const SUPPORT_PHONE_DISPLAY = '(936) 213-0927';
export const SUPPORT_PHONE_TEL = 'tel:+19362130927';

/** Pages where the sticky call banner should appear (info, funnel, resources). */
export function shouldShowCallBanner(pathname: string): boolean {
  return (
    pathname === '/' ||
    pathname.startsWith('/get-quote') ||
    pathname.startsWith('/car-insurance') ||
    pathname.startsWith('/home-insurance') ||
    pathname.startsWith('/pet-insurance') ||
    pathname.startsWith('/qualify') ||
    pathname.startsWith('/insurance/new') ||
    pathname.startsWith('/insurance/car') ||
    pathname.startsWith('/insurance/pet') ||
    pathname.startsWith('/insurance/home') ||
    pathname.startsWith('/knowledge-base') ||
    pathname.startsWith('/help') ||
    pathname.startsWith('/about') ||
    pathname.startsWith('/blog') ||
    pathname.startsWith('/referral') ||
    pathname.startsWith('/terms') ||
    pathname.startsWith('/privacy')
  );
}
